import clsx from 'clsx';

import css from './Actions.module.scss';

const actionsContent = {
  buttons: {
    signin: {
      href: 'https://account.riib.com/Home/Signup',
      text: 'Sign In',
    },
    started: {
      href: 'https://account.riib.com/Home/Signup',
      text: 'Get Started',
    },
  },
};

const Actions = ({ isMobile, buttonsData }) => {
  return (
    <div
      className={clsx(
        css.actions,
        !isMobile && css.header,
        isMobile && css.mobmenu
      )}
    >
      {buttonsData.map(({ href, newtab, text, style, id }) => (
        <a
          key={id}
          href={href}
          target={newtab ? '_blank' : '_self '}
          className={clsx(css.btn, style === 'blue' && css.isBlue)}
        >
          {text}
        </a>
      ))}
    </div>
  );
};

export default Actions;
